import styled from 'vue-styled-components';

export const BusFrontContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: baseline;
  /* margin-right: 100px; */
`
